//FIXME: temporary function because we can't get the file type from the backend currently
export const isPdfFileFromURL = (URL) => {
  return URL?.includes('.pdf');
};
